import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * MessageBubble — Single chat message with avatar, text, and hover timestamp.
 *
 * Received messages align left with sender avatar.
 * Sent messages align right with own avatar.
 * Consecutive same-sender messages collapse the avatar.
 */
function MessageBubble({ message, senderAvatar, senderName, showAvatar }) {
  const [showTimestamp, setShowTimestamp] = useState(false);

  const formatTime = (ts) => {
    const date = new Date(ts);
    return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  };

  const formatDate = (ts) => {
    const date = new Date(ts);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return 'Today';
    if (date.toDateString() === yesterday.toDateString()) return 'Yesterday';
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  };

  return (
    <div
      className={`msg-bubble ${message.isOwn ? 'msg-bubble--sent' : 'msg-bubble--received'} ${!showAvatar ? 'msg-bubble--grouped' : ''}`}
      onMouseEnter={() => setShowTimestamp(true)}
      onMouseLeave={() => setShowTimestamp(false)}
    >
      {!message.isOwn && (
        <div className="msg-bubble__avatar-col">
          {showAvatar ? (
            <img src={senderAvatar} alt="" className="msg-bubble__avatar" />
          ) : (
            <div className="msg-bubble__avatar-spacer" />
          )}
        </div>
      )}

      <div className="msg-bubble__content">
        <div className="msg-bubble__text">{message.text}</div>
        <div className={`msg-bubble__timestamp ${showTimestamp ? 'msg-bubble__timestamp--visible' : ''}`}>
          {formatDate(message.timestamp)} {formatTime(message.timestamp)}
        </div>
      </div>

      {message.isOwn && (
        <div className="msg-bubble__avatar-col msg-bubble__avatar-col--right">
          {showAvatar ? (
            <img src={senderAvatar} alt="" className="msg-bubble__avatar msg-bubble__avatar--small" />
          ) : (
            <div className="msg-bubble__avatar-spacer msg-bubble__avatar-spacer--small" />
          )}
        </div>
      )}
    </div>
  );
}

MessageBubble.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    senderId: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
    isOwn: PropTypes.bool.isRequired,
  }).isRequired,
  senderAvatar: PropTypes.string.isRequired,
  senderName: PropTypes.string,
  showAvatar: PropTypes.bool,
};

export default MessageBubble;
